import { Link } from 'react-router-dom'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'

const getClickableAreaProps = (clickNavigatesTo: string) => {
  const isEmbed = window.self !== window.top
  return {
    is: isEmbed ? ('a' as any) : Link,
    to: isEmbed ? undefined : clickNavigatesTo,
    target: isEmbed ? '_blank' : undefined,
    href: isEmbed ? clickNavigatesTo : undefined,
    textDecoration: 'none',
  }
}

export const getStandardClickableAreaProps = (cardType: CardTypeEnum, clickNavigatesTo?: string) => {
  return clickNavigatesTo && cardType !== CardTypeEnum.UPCOMING ? getClickableAreaProps(clickNavigatesTo) : undefined
}

export const getReducedClickableAreaProps = (cardType: CardTypeEnum, clickNavigatesTo?: string) => {
  return clickNavigatesTo && cardType === CardTypeEnum.UPCOMING ? getClickableAreaProps(clickNavigatesTo) : undefined
}
